/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import moment from 'moment'
import { Button } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

class Download extends React.Component {
  fileReader = new FileReader()
  fileInputRef = React.createRef()
  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    downloadUrl: '',
  }

  onDownloadClick = async () => {
    const { data } = this.props

    if (data) {
      const arrangedData = this.arrangeData(data)
      const csvString = this.generateCSV(arrangedData)
      const snapshot = await this.uploadFile(csvString)
      this.downloadFile(snapshot)
    }
  }

  onClearFile = () => {
    this.fileReader.abort()
    this.fileInputRef.value = ''
  }

  arrangeData = data => {
    return data.map(cashOut => {
      const {
        id,
        deliverer_name,
        deliverer,
        aba_name,
        aba_number,
        amount,
        created_at,
        updated_at,
        status,
      } = cashOut
      return [
        id,
        deliverer_name,
        deliverer,
        aba_number,
        aba_name,
        amount,
        moment(created_at).format('DD-MM-YYYY') + '-' + moment(created_at).format('HH:mm a'),
        moment(updated_at).format('DD-MM-YYYY') + '-' + moment(updated_at).format('HH:mm a'),
        status,
      ]
    })
  }

  generateCSV = data => {
    const { header } = this.props
    let csvString = ''

    csvString = csvString.concat(`${header.join(', ')} \n`)
    csvString = csvString.concat(`${data.join('\n')} \n`)

    return csvString
  }

  onReadFile = () => {
    const self = this

    this.fileReader.onload = event => {
      const dataFromJSON = JSON.parse(event.target.result)
      self.props.getOrderByDateSuccess(dataFromJSON)
      self.onClearFile()
    }

    this.fileReader.onloadstart = () => {
      self.setState({ uploading: true })
    }
    this.fileReader.onloadend = () => {
      self.setState({ uploading: false })
    }
  }

  onFileChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.onReadFile()
      this.fileReader.readAsText(file)
    }
  }

  uploadFile = async csvString => {
    const { filename } = this.props
    const storage = firebase
      .storage()
      .ref()
      .child(`report/${filename}.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  render() {
    const { downloadUrl, data } = this.state

    return (
      <div style={{ marginTop: 10 }}>
        <Button
          disabled={data && data.length === 0}
          // loading={downloading}
          onClick={this.onDownloadClick}
        >
          Download
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <input
          type="file"
          accept=".csv"
          hidden
          ref={ref => {
            this.fileInputRef = ref
          }}
          onChange={this.onFileChange}
        />
      </div>
    )
  }
}

export default Download



// WEBPACK FOOTER //
// ./src/containers/cashOuts/components/Download.js